const LS_PREFIX = 'erp.list-detail-open:';

const VALID = new Set(['page', 'popup', 'side']);

/**
 * @param {string} storageKey e.g. "contacts"
 * @returns {'page' | 'popup' | 'side'}
 */
export function readListDetailOpenMode(storageKey) {
  if (!storageKey || typeof window === 'undefined') return 'page';
  try {
    const v = localStorage.getItem(LS_PREFIX + storageKey);
    if (v && VALID.has(v)) return v;
    // One-time compatibility: Job Requirements used this key before shared helper existed.
    if (storageKey === 'jobs') {
      const legacy = localStorage.getItem('erp.jobs.detailOpenMode');
      if (legacy && VALID.has(legacy)) return legacy;
    }
  } catch {
    /* ignore */
  }
  return 'page';
}

export function writeListDetailOpenMode(storageKey, mode) {
  if (!storageKey || typeof window === 'undefined' || !VALID.has(mode)) return;
  try {
    localStorage.setItem(LS_PREFIX + storageKey, mode);
  } catch {
    /* ignore */
  }
}
